'use client';

import { useState } from 'react';
import { Button } from 'reactstrap';

interface TruncatedTextProps {
  textContent?: string;
  collapseText?: string;
  expandText?: string;
}

const TruncatedText = ({
  textContent = '',
  collapseText = 'Show Less',
  expandText = 'Show All',
}: TruncatedTextProps) => {
  const [showTruncatedText, setShowTruncatedText] = useState(false);
  return (
    <span className={`${!showTruncatedText ? 'no-white-space' : ''}`}>
      {showTruncatedText ? textContent : textContent?.substring(0, 220)}
      {textContent?.length > 220 && !showTruncatedText ? '...' : ''}
      {textContent?.length > 220
        ? (
          <Button
            type="button"
            color="link"
            onClick={() => setShowTruncatedText(!showTruncatedText)}
          >
          &nbsp;
            {showTruncatedText ? collapseText : expandText}
          </Button>
        )
        : ''}
    </span>
  );
};

export default TruncatedText;
